import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { completeLogin } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      setError("Aucune session détectée.");
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    axios
      .post(`${API}/auth/session`, { session_id }, { withCredentials: true })
      .then((r) => {
        window.history.replaceState(null, "", window.location.pathname);
        completeLogin(r.data);
        navigate("/profil", { replace: true, state: { user: r.data } });
      })
      .catch(() => {
        setError("La connexion Google a échoué ou la session a expiré. Réessayez.");
      });
  }, [location.hash, completeLogin, navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-night px-6 text-center">
      {error ? (
        <>
          <p className="font-display text-3xl font-extrabold uppercase text-white">Connexion interrompue</p>
          <p className="mt-3 max-w-sm text-sm text-slate-400">{error}</p>
          <button
            data-testid="auth-callback-retry-btn"
            onClick={() => navigate("/", { replace: true })}
            className="mt-8 rounded-full bg-neon px-7 py-3.5 text-xs font-extrabold uppercase tracking-wider text-night chip-glow"
          >
            Retour à l'accueil
          </button>
        </>
      ) : (
        <>
          <Loader2 size={44} className="animate-spin text-neon" />
          <p className="mt-6 font-display text-2xl font-extrabold uppercase tracking-tight text-white">
            Connexion en cours…
          </p>
          <p className="mt-2 text-sm text-slate-400">Nous finalisons votre connexion Google.</p>
        </>
      )}
    </div>
  );
}
